import React, { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import {
  Card,
  Box,
  Typography,
  Grid,
  Divider,
  Paper,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,  
} from "@mui/material";
import { useAuth } from "../../../../AuthProvider";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import './HallticketList.css'


const HallTicketTemplate3 = () => {
   const { Examtype } = useParams(); 
  const location = useLocation();
  const navigate = useNavigate();
  const { student } = location.state || {};
  const componentRef = useRef();
  const {userId,pId, oId,board,role } = useAuth();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const { admissionNumber,examtype } = useParams();
  const [filteredData, setFilteredData] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState("");
const [sscSelectedSection, setSscSelectedSection] = useState("");

  // INTERMEDIATE STATES
  const [interSelectedClass, setInterSelectedClass] = useState("");
  const [interSelectedSection, setInterSelectedSection] = useState("");
  const [course, setCourse] = useState([]);

  const examType = filteredData?.[0]?.examType || "";

  // Extract unique timings from filteredData
const uniqueTimings = [
  ...new Set(
    filteredData.map(item => `${item.examTime} to ${item.examTimeEnd}`)
  )
];
  const [originalData, setOriginalData] = useState({});
  const [loading, setLoading] = useState(true);
   const [companyInfo, setCompanyInfo] = useState({
          schoolName: "",
          pincode: "",
          primaryContact: "",
          secondaryContact: "",
          boardAffiliation: "",
          schoolAddress: "",
          affiliationNumber: "",
          city: "",
          state: "",
          schoolEmailId: "",
          schoolLogo: "",
          schoolStamp: "",
        });
        const [tempInfo, setTempInfo] = useState({ ...companyInfo });
        const [orgloading, setOrgLoading] = useState(true); 
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState("");
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;
    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/EXAMINATION_CELL/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
useEffect(() => {
  if (isPrincipal) {
    fetchUsers();
  }
}, []); // ✅ Only runs on mount

  // ---- Fetch Table Data for SSC ----
const fetchClassSectionTableData = async (romanNumberClass, Examtype) => {
  if (!romanNumberClass ||!sscSelectedSection || !Examtype) {
    setFilteredData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      
      `${baseUrl}/api/examCell/getWithRomanNumberClassWithExamType/${oId}/${pId}/${UserId}?romanNumberClass=${romanNumberClass}&sections=${sscSelectedSection}&examType=${Examtype}`
    );
    const data = await response.json();

    if (Array.isArray(data) && data.length > 0) {
      setFilteredData(data);
    } else {
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching exam timetable:", error);
  } finally {
    setLoading(false);
  }
};
useEffect(() => {
  if (board === "SSC" && sscSelectedClass && Examtype && oId) {
    fetchClassSectionTableData(sscSelectedClass, Examtype);
  }
  
}, [sscSelectedClass,sscSelectedSection, Examtype, board, oId]);

  // ---- Fetch Table Data for INTERMEDIATE ----
const fetchCourseClassSectionTableData = async (romanNumberClass, Examtype,course) => {
  if (!romanNumberClass ||!interSelectedSection ||  !Examtype ||!course) {
    setFilteredData([]);
    setLoading(false);
    return;
  }
  setLoading(true);
  try {
    const response = await fetch(
      
      `${baseUrl}/api/examCell/getWithRomanNumberClassWithExamType/${oId}/${pId}/${UserId}?romanNumberClass=${romanNumberClass}&sections=${interSelectedSection}&examType=${Examtype}&course=${course}`
    );
    const data = await response.json();

    if (Array.isArray(data) && data.length > 0) {
      setFilteredData(data);
    } else {
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching exam timetable:", error);
  } finally {
    setLoading(false);
  }
};
useEffect(() => {
  if (board === "INTERMEDIATE" && interSelectedClass && Examtype && oId && course) {
    fetchCourseClassSectionTableData(interSelectedClass, Examtype,course);
  }
  
}, [interSelectedClass,interSelectedSection, course,Examtype, board, oId]);

useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/admission/getAllStudentsDetailsAdmIdForHallTicket/${admissionNumber}/${oId}/${pId}?examType=${Examtype}`
      );
      const data = await response.json();
      setOriginalData(data);
      if (board === "SSC" && data?.romanNumberClass) {
        setSscSelectedClass(data.romanNumberClass);
        setSscSelectedSection(data.sections);
      }
       else if (board === "INTERMEDIATE" && data?.romanNumberClass && data?.course) {
        setInterSelectedClass(data.romanNumberClass);
        setInterSelectedSection(data.sections);
        setCourse(data.course);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [admissionNumber, baseUrl, board]);

  //organization details api 
          useEffect(() => {
            const fetchCompanyInfo = async () => {
              try {
                const response = await fetch(`${baseUrl}/api/v1/organisation/${oId}`);
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                const data = await response.json();
                setCompanyInfo({
                  schoolLogo: data.schoolLogo,
                  schoolStamp:data.schoolStamp,
                  schoolName: data.schoolName,
                  city: data.city,
                  state: data.state,
                  affiliationNumber: data.affiliationNumber,
                  schoolAddress: data.schoolAddress,
                  primaryContact: data.primaryContact,
                  boardAffiliation: data.boardAffiliation,
                  secondaryContact: data.secondaryContact,
                  pincode: data.pincode,
                  schoolEmailId: data.schoolEmailId,
                });
                setTempInfo(data);
        
                setOrgLoading(false); // Data fetched, stop loading
        
              } catch (error) {
                console.error("Error fetching company info:", error);
                setOrgLoading(false); // Stop loading even if there's an error
              }
            };
        
            fetchCompanyInfo();
          }, []);


          const formatExamType = (type) => {
  if (!type) return "";
  const [prefix, number] = type.split("-");
  switch (prefix) {
    case "FA":
      return `Formative Assessment - ${number}`;
    case "SA":
      return `Summative Assessment - ${number}`;
    default:
      return type;
  }
};

const groupedData = filteredData.reduce((acc, curr) => {
  if (!acc[curr.examDate]) {
    acc[curr.examDate] = [];
  }
  acc[curr.examDate].push(curr);
  return acc;
}, {});

Object.keys(groupedData).forEach(date => {
  groupedData[date].sort((a, b) => {
    const getTimeValue = (time) => {
      const [hours, minutes, period] = time.match(/(\d+):(\d+)\s?(AM|PM)/i).slice(1);
      let h = parseInt(hours, 10);
      const m = parseInt(minutes, 10);
      if (period.toUpperCase() === "PM" && h !== 12) h += 12;
      if (period.toUpperCase() === "AM" && h === 12) h = 0;
      return h * 60 + m;
    };
    return getTimeValue(a.examTime) - getTimeValue(b.examTime);
  });
});

  const PrintableHallTicket = React.forwardRef((props, ref) => (
    <div ref={ref} style={{ padding: "20px" }}>
      <Paper
        elevation={3}
        sx={{
          mt: 4,
          p: 2,
          width: "210mm",
          // height: "297mm",
          border: "2px solid black",
          position: "relative",
          '@media print': {
            display: "block",
          },
        }}
      >
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box width="20%">
            <img
              src={`data:image/jpeg;base64,${companyInfo.schoolLogo}`}
              alt="Logo"
              style={{
                width: "100px",         // Set a single value
                height: "100px",        // Match the width exactly
                borderRadius: "50%",    // Ensures circle
                objectFit: "cover",     // Ensures image fills without distortion
              }}
            />

          </Box>
          <Box textAlign="center" flexGrow={1}>
             <Grid item xs={12} sm={8}>
                                            <Grid container direction="column" spacing={1}>
                                              <Grid item>
                                                <Typography variant="h4" style={{ fontWeight: "bold", color: "red" }}>
                                                  {companyInfo.schoolName}
                                                </Typography>
                                              </Grid>
            
                                              <Grid item>
                                                <Typography variant="h5" style={{ fontWeight: "bold", }}>
                                                  {formatExamType(Examtype)}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          </Grid>
            <Typography
                          sx={{
                            mt: 2,
                            paddingBottom: "15px",
                            fontWeight: "bold",
                            fontFamily: "Arial, sans-serif",
                            fontSize: "12px", // Optional: Adjust font size
                            color: "#333", // Optional: Adjust font color
                            textAlign:'center'
                          }}
                          >
                          HALLTICKET
                        </Typography>

          </Box>
          <Box width="20%" />
        </Box>

        <Divider sx={{ my: 1 }} />
<Grid container spacing={1}>
 
<Grid item xs={12}>
  <Grid container spacing={2}>
    {/* Class */}
    <Grid item xs={6}>
      <Box display="flex" alignItems="center">
        <Box minWidth={180}>
          <Typography fontWeight="bold">Class</Typography>
        </Box>
        <Typography sx={{ mx: 1 }}>:</Typography>
        <Box borderBottom="1px solid black" width="100%" pb={0.5}>
          <Typography variant="body1">
            {originalData?.romanNumberClass || ""}
          </Typography>
        </Box>
      </Box>
    </Grid>

    {/* Section */}
    <Grid item xs={6}>
      <Box display="flex" >
        <Box minWidth={100}>
          <Typography fontWeight="bold" sx={{paddingRight:'10px'}}>Section</Typography>
        </Box>
        <Typography sx={{paddingRight:'5px'}}>: </Typography>
        <Box borderBottom="1px solid black" width="100%" pb={0.5}>
          <Typography variant="body1">
            {originalData?.sections || ""}
          </Typography>
        </Box>
      </Box>
    </Grid>
  </Grid>
</Grid>
 {/* 🔹 Roll Number and HALLTICKET NO in same row (side by side) */}
<Grid item xs={12}>
  <Grid container spacing={2}>
    {/* Roll Number */}
    <Grid item xs={6}>
      <Box display="flex" alignItems="center">
        <Box minWidth={180}>
          <Typography fontWeight="bold">Roll Number</Typography>
        </Box>
        <Typography sx={{ mx: 1 }}>:</Typography>
        <Box borderBottom="1px solid black" width="100%" pb={0.5}>
          <Typography variant="body1">
            {originalData?.studentRollNumber || "N/A"}
          </Typography>
        </Box>
      </Box>
    </Grid>

    {/* Hallticket No */}
    <Grid item xs={6}>
      <Box display="flex" >
        <Box minWidth={100}>
          <Typography fontWeight="bold" sx={{paddingRight:'10px'}}>HallTicket No</Typography>
        </Box>
        <Typography sx={{paddingRight:'5px'}}>: </Typography>
        <Box borderBottom="1px solid black" width="100%" pb={0.5}>
          <Typography variant="body1">
            {originalData?.studentHallTicket || ""}
          </Typography>
        </Box>
      </Box>
    </Grid>
  </Grid>
</Grid>

  <Grid item xs={12}>
    <Grid container spacing={2}>
      {/* Name of the Student */}
      <Grid item xs={6}>
        <Box display="flex" alignItems="center">
          <Box minWidth={180}>
            <Typography fontWeight="bold">Name of the Student</Typography>
          </Box>
          <Typography sx={{ mx: 1 }}>:</Typography>
          <Box borderBottom="1px solid black" width="100%" pb={0.5}>
            <Typography variant="body1">
              {`${originalData?.surName || ""} ${originalData?.firstName || ""} ${originalData?.lastName || ""}`}
            </Typography>
          </Box>
        </Box>
      </Grid>
  
      {/* Father Name */}
      <Grid item xs={6}>
        <Box display="flex" >
          <Box minWidth={100}>
            <Typography fontWeight="bold" sx={{paddingRight:'10px'}}>Father Name</Typography>
          </Box>
          <Typography sx={{paddingRight:'5px'}}>: </Typography>
          <Box borderBottom="1px solid black" width="100%" pb={0.5}>
            <Typography variant="body1">
              {(() => {
                const fullName = [
                  originalData?.surName,
                  originalData?.fathersFirstName,
                  originalData?.fathersLastName
                ]
                  .filter(Boolean) // remove empty values
                  .join(" ");
                return fullName || "N/A";
              })()}
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  </Grid>
</Grid>
        <Divider sx={{ my: 1 }} />
<Table sx={{ mt: 2, border: "1px solid #000" }} size="small">

 <TableHead>
  {/* Dates Row */}
  <TableRow>
    <TableCell
      align="center"
      sx={{ fontWeight: "bold", border: "1px solid #000", padding: "4px", fontSize: "14px" }}
    >
      Exam Date
    </TableCell>
    {Object.keys(groupedData).map((date, index) => (
      <TableCell
        key={index}
        align="center"
        sx={{ border: "1px solid #000", padding: "4px", fontSize: "14px" }}
      >
        {/* {date} */}
         {new Date(date).toLocaleDateString("en-GB")} 
      </TableCell>
    ))}
  </TableRow>

  {/* Subjects Row */}
  <TableRow>
    <TableCell
      align="center"
      sx={{ fontWeight: "bold", border: "1px solid #000", padding: "4px", fontSize: "14px" }}
    >
      Subject
    </TableCell>
    {Object.keys(groupedData).map((date, index) => (
      <TableCell
        key={index}
        align="center"
        sx={{ border: "1px solid #000", padding: "4px", fontSize: "14px" }}
      >
        {groupedData[date].map(item => item.subject).join(" / ")}
      </TableCell>
    ))}
  </TableRow>

  {/* Invigilator Row */}
  <TableRow>
    <TableCell
      align="center"
      sx={{ fontWeight: "bold", border: "1px solid #000", padding: "4px", fontSize: "14px" }}
    >
      Invigilator Signature
    </TableCell>
    {Object.keys(groupedData).map((date, index) => (
      <TableCell
        key={index}
        align="center"
        sx={{ border: "1px solid #000", padding: "4px", fontSize: "14px" }}
      >
        {groupedData[date].map(item => item.invigilatorSignature).join("")}
      </TableCell>
    ))}
  </TableRow>
</TableHead>
  {/* CONDITIONAL BODY HERE */}
  {filteredData.length === 0 ? (
    <TableBody>
      <TableRow>
        <TableCell colSpan={13} sx={{ textAlign: "center" }}>
           No TimeTable Data Available
        </TableCell>
      </TableRow>
    </TableBody>
  ) : (
    <TableBody>
      {filteredData.map((row, index) => (
        <TableRow
          key={index}
          hover
          sx={{
            backgroundColor: "white",
            transition: "background-color 0.3s",
            "&:hover": { backgroundColor: "#f5f5f5" },
          }}
        >
           </TableRow>
      ))}
    </TableBody>
  )}
</Table>

{/* Exam Timings */}
<Box mt={2}>
  <Typography variant="body1" fontWeight="bold">
    Timings: {uniqueTimings.join(" / ")}
  </Typography>
</Box>
<Box mt={4} display="flex" justifyContent="space-between">
  {/* Student Signature */}
  <Box textAlign="center" sx={{ fontSize: "13px" }}>
    {/* <Typography sx={{ mb: 1 }}>_________________</Typography> */}
    <Typography fontWeight="bold">Student Signature</Typography>
  </Box>

  {/* Principal Signature */}
  <Box textAlign="center" sx={{ fontSize: "13px" }}>
    {/* <Typography sx={{ mb: 1 }}>_________________</Typography> */}
    <Typography fontWeight="bold">Principal Signature</Typography>
  </Box>
</Box>
      </Paper>
    </div>
  ));

  return (
    <Card
      className="main-card"
      sx={{
        borderRadius: "16px",
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
        backgroundColor: "#f4f6f9",
        margin: "60px 1% 1%",
        padding: "20px",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <PrintableHallTicket ref={componentRef} />

      <div
              style={{
                position: "absolute",
                top: "20px",
                left: "20px",
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
                <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
                  <KeyboardBackspaceIcon fontSize="medium" />
                </IconButton>
                <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
                  Hallticket
                </Typography>

              </Box>
            </div>

      {/* Print Button */}
      <Box
        className="print-hide"
        sx={{
          position: "absolute",
          top: "20px",
          right: "20px",
          display: "flex",
          gap: "10px",
        }}
      >
        <button
          onClick={handlePrint}
          style={{
            padding: "8px 16px",
            borderRadius: "8px",
            color: "#fff",
            cursor: "pointer",
            background: "linear-gradient(90deg, #3C3972, #3C3972)",
            border: "none",
            fontWeight: "bold",
            fontSize: "14px",
            boxShadow: "0 5px 10px rgba(30, 144, 255, 0.3)",
          }}
        >
          Print
        </button>
      </Box>

      {/* Print-specific styles */}
      <style>{`
        @media print {
          @page {
            size: A4;
            margin: 10mm;
          }
          body {
            background: white;
            width: 100%;
          }
          .print-hide {
            display: none;
          }
        }
      `}</style>
    </Card>
  );
};

export default HallTicketTemplate3;
